export default "__VITE_ASSET__BjT9bFiJ__"